<ul class="notifications">
  <li class="notifications_list_item" *ngFor="let n of notifications">
    <a
      *ngIf="n.notification.type === 'LINK'"
      [href]="n.notification.text"
      download
      >{{ checkLinkType(n.notification.text) }} {{ n.notification.text }}</a
    >
    <span
      *ngIf="n.notification.type !== 'LINK'"
      class="notification position-relative"
      >{{ n.notification.text }}</span
    >
    <div *ngIf="n.notification.type === 'REG' && n.user">
      <div class="notifications_user_info">
        <div>{{ n.user?.full_name }} ({{ n.user?.email }})</div>

        <div>{{ n.user?.phone_number }}</div>
      </div>
      <a
        (click)="confirmUser(n.user!.id, n.notification.id)"
        class="notifications_btn"
        >Подтвердить пользователя</a
      >
    </div>
  </li>
</ul>
